<template>
  <TempuraBody />
</template>

<script>
import TempuraBody from '../molecules/TempuraBody.vue'


export default {
  name: 'TempuraView',
  components: {
    TempuraBody,
  }
}
</script>
